<div class="third-parties-banner">
  <img class="third-parties-banner_default" *ngIf="defaultImg" [hidden]="srcLogo" [src]="defaultImg"  alt="banner">

  <div
    *ngIf="srcLogo"
    class="third-parties-banner_banner-img"
    (contextmenu)="showCustomMenu($event)"
    (click)="fetchImage()"
    [pTooltip]="isContextMenuVisible ? 'Click to change image. Right click to see context menu' : 'Click to change image'"
    [style.background-image]='"url(\"" + srcLogo + "\")"'>
  </div>
  <div id="custom-menu" *ngIf="customMenuVisible" [style.left.px]="menuPosition.x" [style.top.px]="menuPosition.y" class="custom-menu">
    <ul>
      <li (click)="fetchImage()" class="first_btn">Change</li>
      <li (click)="deleteImage()">Delete</li>
    </ul>
  </div>
  <span
    class="add-btn"
    [hidden]="srcLogo"
    (click)="fetchImage()"
    [pTooltip]="isLoading ? 'Please, wait' : 'Upload banner image'"
    [ngClass]="{'pointer': !isLoading}">
      <ng-container *ngIf="!isLoading; else smallSpinner">
        <img src="./assets/images/plus-circle-dotted.svg" alt="">
        <input
          #imageInput
          type="file"
          [accept]="photoAllowedExt"
          [size]="fileSize"
          (change)="uploadImage($event)"
          [hidden]="true"
          name="budgetLogo">
      </ng-container>
  </span>
</div>

<ng-template #smallSpinner>
  <i class="fa-spin fas fa-spinner"></i>
</ng-template>
